// Schnellfilter fuer den Finanz-Dashboard-Zeitraum - ersetzt die reinen Von/Bis-Felder der
// alten Uebersicht. Berechnet von/bis lokal, "benutzerdefiniert" blendet die Datumsfelder ein.
import THEME from "../../../theme";
import { fs } from "../utils/styles";

function heuteISO(d) {
  // Lokales Datum statt toISOString() (UTC): sonst rutscht der 1. eines Monats (lokal 00:00) in der
  // Sommerzeit auf den 31. des Vormonats - "Letzter Monat" enthielt dadurch faelschlich den Vormonatsletzten.
  const p = n => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function zeitraumFuerPreset(preset) {
  const heute = new Date();
  if (preset === "heute") {
    return { von: heuteISO(heute), bis: heuteISO(heute) };
  }
  if (preset === "diese_woche") {
    const wochentag = (heute.getDay() + 6) % 7; // Montag = 0
    const montag = new Date(heute); montag.setDate(heute.getDate() - wochentag);
    return { von: heuteISO(montag), bis: heuteISO(heute) };
  }
  if (preset === "dieser_monat") {
    return { von: heuteISO(new Date(heute.getFullYear(), heute.getMonth(), 1)), bis: heuteISO(heute) };
  }
  if (preset === "letzter_monat") {
    const ersterDiesen = new Date(heute.getFullYear(), heute.getMonth(), 1);
    const letzterVormonat = new Date(ersterDiesen - 1);
    const ersterVormonat = new Date(letzterVormonat.getFullYear(), letzterVormonat.getMonth(), 1);
    return { von: heuteISO(ersterVormonat), bis: heuteISO(letzterVormonat) };
  }
  if (preset === "dieses_jahr") {
    return { von: heuteISO(new Date(heute.getFullYear(), 0, 1)), bis: heuteISO(heute) };
  }
  return { von: "", bis: "" };
}

const PRESETS = [
  ["heute", "Heute"], ["diese_woche", "Diese Woche"], ["dieser_monat", "Dieser Monat"],
  ["letzter_monat", "Letzter Monat"], ["dieses_jahr", "Dieses Jahr"], ["eigen", "Benutzerdefiniert"],
];

export default function ZeitraumFilter({ preset, onPresetWechsel, von, bis, onVonChange, onBisChange }) {
  return (
    <div style={{ ...fs.karte, marginBottom: 20, display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
      {PRESETS.map(([key, label]) => (
        <button key={key} onClick={() => onPresetWechsel(key)} style={{
          ...fs.btnGray, width: "auto", padding: "8px 16px",
          background: preset === key ? THEME.colors.primary : THEME.colors.surfaceMuted,
        }}>{label}</button>
      ))}
      {preset === "eigen" && (
        <>
          <input type="date" style={{ ...fs.input, width: "auto" }} value={von} onChange={e => onVonChange(e.target.value)} />
          <span style={{ color: THEME.colors.textMuted }}>bis</span>
          <input type="date" style={{ ...fs.input, width: "auto" }} value={bis} onChange={e => onBisChange(e.target.value)} />
        </>
      )}
    </div>
  );
}
